import { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const PhoneFrame = ({ children, footer }) => {
  const [time, setTime] = useState(() =>
    new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })
  );
  useEffect(() => {
    const t = setInterval(
      () =>
        setTime(
          new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          })
        ),
      10000
    );
    return () => clearInterval(t);
  }, []);

  const nav = useNavigate();

  return (
    <div className="phone-shell-wrapper" data-testid="phone-shell-wrapper">
      {/* Back to Website Button (Desktop Only) */}
      <div className="hidden md:block absolute top-8 left-8 z-[100]">
        <button
          onClick={() => nav("/")}
          className="flex items-center gap-2 px-5 py-2.5 bg-white/80 backdrop-blur-md border border-gray-200 rounded-full font-bold text-gray-700 hover:bg-white hover:shadow-lg transition-all"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to website
        </button>
      </div>

      <div className="phone-shell" data-testid="phone-shell">
        <div className="phone-notch" />
        <div className="status-bar">
          <span data-testid="status-bar-time">{time}</span>

        </div>
        <div className="screen-area phone-scroll" data-testid="screen-area">
          {children}
        </div>
        {footer}
      </div>
    </div>
  );
};

export default PhoneFrame;
